<template>
  <v-col v-if="datas.length > 0" cols="12" class="test_blue">
    <v-radio-group
      v-model="selected"
      mandatory
      class="input-group-radio-stretch"
    >
      <template v-slot:label>
        <span class="modal-title-details" v-text="$t('general.variations')" />
      </template>
      <template v-for="(item, index) in datas">
        <v-radio :key="index" :value="item.id">
          <template v-slot:label>
            <v-container fluid fill-height style="padding: 6px 2px">
              <v-row no-gutters justify="space-between">
                <span class="modal-name-details" v-text="item.name" />
                <span
                  :class="show(item.id) ? 'active' : 'inactive'"
                  class="modal-price-details"
                  v-text="$appFormatters.formatMoney(item.sellingPrice)"
                />
              </v-row>
            </v-container>
          </template>
        </v-radio>
      </template>
    </v-radio-group>

    <v-divider class="mx-1 mt-3" />
  </v-col>
</template>

<script>
export default {
  name: "VariationsComponent",
  props: {
    datas: {
      type: Array,
      default: null,
    },
  },
  data: () => ({
    selected: 0,
    detailsSelected: [],
  }),
  watch: {
    selected: function (id) {
      this.detailsSelected = [];
      this.creatArray(id);
    },
    detailsSelected: function () {
      this.$emit("input", this.detailsSelected);
    },
  },
  methods: {
    creatArray: function (id) {
      const self = this;
      let item = _.find(self.datas, {
        id: id,
      });
      self.detailsSelected = {
        id: id,
        price: item.sellingPrice,
      };
    },
    show: function (id) {
      const self = this;
      return self.selected === id;
    },
  },
};
</script>
